import { useRef } from "react";
import { useNavigate } from "react-router-dom";

const BotonSOS = () => {
  const navigate = useNavigate();
  const navegando = useRef(false);

  const handleClick = () => {
    if (navegando.current) return;
    navegando.current = true;

    if (!navigator.geolocation) {
      navigate("/panico");
      return;
    }

    navigator.permissions
      .query({ name: "geolocation" })
      .then((result) => {
        if (result.state === "prompt") {
          navigator.geolocation.getCurrentPosition(
            () => navigate("/panico"),
            () => navigate("/panico"),
            { timeout: 10000, maximumAge: 0 }
          );
        } else {
          navigate("/panico");
        }
      })
      .catch(() => navigate("/panico"));
  };

  return (
    <button
      onClick={handleClick}
      style={{
        position: "fixed", bottom: 20, right: 20,
        width: 60, height: 60, borderRadius: "50%",
        backgroundColor: "#ff4747", color: "#fff",
        border: "none", fontSize: 11, fontWeight: "bold",
        cursor: "pointer", boxShadow: "0 6px 14px rgba(0,0,0,0.25)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1001, letterSpacing: 1,
      }}
    >
      SOS
    </button>
  );
};

export default BotonSOS;
